var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M10 9a1 1 0 0 1 1 1v6.5a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1Zm5 1a1 1 0 1 0-2 0v6.5a1 1 0 1 0 2 0V10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    fillRule: "evenodd",
    d: "M9.645 1a1 1 0 0 0-.877.52L7.408 4H2a1 1 0 0 0 0 2h1.5v16a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V6H22a1 1 0 1 0 0-2h-5.402L15.27 1.527A1 1 0 0 0 14.389 1H9.645Zm4.683 3-.537-1h-3.554l-.548 1h4.639ZM5.5 6v15h13V6h-13Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.91709cd0.svg";
export { ForwardRef as ReactComponent };